<template>
    <!-- play -->
    <div  v-if="play">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g id="그룹_16191" data-name="그룹 16191" transform="translate(-281 -114)">
                <g id="그룹_16178" data-name="그룹 16178" transform="translate(-7 23)">
                <circle id="타원_436" data-name="타원 436" cx="20" cy="20" r="20" transform="translate(288 91)" fill="#f5f5f5"/>
                </g>
                <path id="다각형_19" data-name="다각형 19" d="M8.8,2.755a2,2,0,0,1,3.4,0l6.914,11.194A2,2,0,0,1,17.414,17H3.586a2,2,0,0,1-1.7-3.051Z" transform="translate(312 124) rotate(90)" fill="#7260ff"/>
            </g>
            </svg>

    </div>
    <!-- pause -->
    <div v-else>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g id="그룹_16191" data-name="그룹 16191" transform="translate(-281 -114)">
                <g id="그룹_16178" data-name="그룹 16178" transform="translate(-7 23)">
                <circle id="타원_436" data-name="타원 436" cx="20" cy="20" r="20" transform="translate(288 91)" fill="#f5f5f5"/>
                </g>
                <g id="그룹_16177" data-name="그룹 16177" transform="translate(123.77 -561)">
                <rect id="사각형_10709" data-name="사각형 10709" width="6" height="20" rx="2" transform="translate(168.231 685)" fill="#7260ff"/>
                <rect id="사각형_10710" data-name="사각형 10710" width="6" height="20" rx="2" transform="translate(180.231 685)" fill="#7260ff"/>
                </g>
            </g>
            </svg>

    </div>
</template>
<script>
export default {
    props:{
        play:Boolean
    }
}
</script>